import React from "react";
import {
  ResponsiveContainer,
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

/**
 * Grouped bar — compare two metrics (e.g. Collected vs Due by class).
 * data: [{ name, keyA, keyB, ... }]
 * series: [{ key, name, color }]
 */
const GroupedBarChart = ({
  data = [],
  series = [
    { key: "collected", name: "Collected", color: "#059669" },
    { key: "due", name: "Due", color: "#D97706" },
  ],
  height = 220,
  layout = "horizontal",
}) => {
  if (!data?.length) {
    return (
      <div
        className="flex items-center justify-center text-xs text-slate-400 dark:text-neutral-500"
        style={{ height }}
      >
        No data
      </div>
    );
  }

  const isHorizontal = layout === "horizontal";

  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <ReBarChart
          data={data}
          layout={isHorizontal ? "vertical" : "horizontal"}
          margin={{ top: 4, right: 8, left: 4, bottom: 0 }}
          barGap={4}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#f1f5f9"
            vertical={!isHorizontal}
            horizontal={isHorizontal}
          />
          {isHorizontal ? (
            <>
              <XAxis
                type="number"
                tick={{ fontSize: 11, fill: "#94a3b8" }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                type="category"
                dataKey="name"
                width={90}
                tick={{ fontSize: 11, fill: "#64748b" }}
                axisLine={false}
                tickLine={false}
              />
            </>
          ) : (
            <>
              <XAxis
                dataKey="name"
                tick={{ fontSize: 11, fill: "#64748b" }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 11, fill: "#94a3b8" }}
                axisLine={false}
                tickLine={false}
                width={44}
              />
            </>
          )}
          <Tooltip
            cursor={{ fill: "#f8fafc" }}
            contentStyle={{
              fontSize: 12,
              borderRadius: 6,
              border: "1px solid #e2e8f0",
              boxShadow: "none",
            }}
            formatter={(v) =>
              typeof v === "number"
                ? `₹${v.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`
                : v
            }
          />
          <Legend
            iconSize={8}
            wrapperStyle={{ fontSize: 11, paddingTop: 4 }}
          />
          {series.map((s) => (
            <Bar
              key={s.key}
              dataKey={s.key}
              name={s.name}
              fill={s.color}
              radius={isHorizontal ? [0, 3, 3, 0] : [3, 3, 0, 0]}
              maxBarSize={18}
              animationDuration={400}
            />
          ))}
        </ReBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GroupedBarChart;
